import {Component, input} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {LoaderComponent} from "../shared/loader/loader.component";
import {TranslocoDirective} from "@jsverse/transloco";
import {MatButton} from "@angular/material/button";
import {RouterLink} from "@angular/router";
import {LoyaltyNumberPipe} from 'shared-lib';

@Component({
  selector: 'app-places-with-benefits',
  imports: [
    TranslocoDirective,
    NgOptimizedImage,
    LoaderComponent,
    MatButton,
    RouterLink,
    LoyaltyNumberPipe
  ],
  templateUrl: './places-with-benefits.component.html',
  styleUrl: './places-with-benefits.component.scss'
})
export class PlacesWithBenefitsComponent {
  loaded = input(false);
}
